/* 夏侯淵傳・第 2 章：東海・降十餘屯（約建安十一年，206）
 * 史實：《三國志·夏侯淵傳》「昌豨反，遣于禁擊之，未拔，復遣淵與禁并力，遂擊豨，降其十餘屯，豨詣禁降。淵還，拜典軍校尉。」
 *       《于禁傳》：豨「與禁有舊，詣禁降」；禁曰「諸君不知公常令乎！圍而後降者不赦」，垂泣而斬之。
 *       《魏書》（裴注）：「典軍校尉夏侯淵，三日五百，六日一千。」
 * 流程：1. 山間四座屯（十餘屯縮成四座）。每屯有「守意」：夏侯淵站在屯裡守意慢慢降，打倒守兵降得更多；歸零時剩下的守兵投降、跟著走。
 *          守兵全被殺光算「破屯」不算降。軍糧有限，拖太久就退兵。
 *       2. 帶著降兵和于禁夾攻昌豨的大屯。昌豨被打到四成，不和夏侯淵打，轉頭往于禁的營去投降（劇情）。于禁斬之。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, vanish } from '../kit.ts';
import { XHY, XTROOPS, F } from './xiahouyuan_kit.ts';
import { START, TUNS, MAIN, YUJIN } from '../maps/xiahouyuan_donghai.ts';

const LV = 8, RING = 650, DRAIN = 6, PER_KILL = 15, FOOD_T = 300;
const MEN = F(XTROOPS.bandit, '昌豨兵', 420, 22), CHIEF = F(XTROOPS.bandit, '屯將', 900, 32, 230);
const NAMES = ['西屯', '北屯', '中屯', '南屯'];

export default {
  id: 'xiahouyuan-2', map: 'xiahouyuan_donghai', hero: 'xiahouyuan',
  title: '第 2 章　東海・降十餘屯', year: '建安十一年（206）',
  brief: {
    quote: [{ text: '昌豨反，遣于禁擊之，未拔，復遣淵與禁并力，遂擊豨，降其十餘屯。', src: '《三國志·魏書·夏侯淵傳》' }],
    text: '東海的昌豨反覆叛降。于禁攻不下來，曹操又派夏侯淵去和于禁合力。昌豨的兵分散在山間的十幾座屯裡。',
    goals: ['逼降四座屯（站在屯裡、打倒守兵，讓守意歸零）', '帶著降兵和于禁夾攻昌豨的大屯', `軍糧只夠 ${FOOD_T / 60} 分鐘`],
  },
  words: { ally: '曹軍', foe: '昌豨兵' },
  stars: [
    { text: '四座屯都是降、不是破', ok: (m) => m.vars.surr === 4 },
    { text: '于禁沒有倒下', ok: (m) => !m.vars.yjDown },
    { text: '昌豨投降時身邊有 8 名以上降兵', ok: (m) => m.vars.menAt >= 8 },
  ],
  steps: [
    { // 1. 降屯
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = START[0]; me.y = START[1];
        V.t0 = w.t; V.surr = 0; V.broken = 0;
        V.tuns = TUNS.map(([x, y], k) => {
          const list = Array.from({ length: 5 }, (_, i) => { const a = (i / 5) * Math.PI * 2; return m.foe('huangjin', x + Math.cos(a) * 200, y + Math.sin(a) * 140, MEN); });
          list.push(m.foe('bandit', x, y, CHIEF));
          m.mark('t' + k, x, y, NAMES[k], true);
          return { k, x, y, list, n0: list.length, res: 100, done: null };
        });
        V.yj = ally(w, 'yujin', YUJIN[0], YUJIN[1], LV); V.yj.hold = YUJIN.slice();
        m.card('昌豨反，遣于禁擊之，未拔，復遣淵與禁并力。', '《夏侯淵傳》');
        m.line('夏侯淵', '昌豨的兵散在山裡的各屯。能降的就降，不必殺光。');
        m.after(4, () => m.line('提示', '站在屯裡（守兵附近），屯的守意會慢慢降；打倒守兵降得更多。守意歸零，剩下的人就投降跟著你。'));
        m.obj('tun', '逼降或攻破四座屯', 4);
        m.obj('food', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        for (const T of V.tuns) {
          if (T.done) continue;
          const alive = m.alive(T.list), lost = T.n0 - alive.length;
          if (T.lost0 == null) T.lost0 = 0;
          if (lost > T.lost0) { T.res -= (lost - T.lost0) * PER_KILL; T.lost0 = lost; }
          if (m.near(me, T.x, T.y, RING)) T.res -= DRAIN * dt;
          if (!alive.length) { T.done = 'broken'; V.broken++; m.unmark('t' + T.k); m.line('夏侯淵', `${NAMES[T.k]}破了……一個也沒降。`); continue; }
          if (T.res <= 0) {
            T.done = 'surr'; V.surr++; m.unmark('t' + T.k);
            for (const u of alive) { u.team = 0; u.recruit = true; u.name = '降兵'; u.target = null; u.aggro = null; u.patrol = null; u.counted = false; m.join(u, me); }
            m.big(`${NAMES[T.k]}降了`);
            w.dmgEvents.push({ x: T.x, y: T.y - 80, text: '降', team: 0, src: me.id });
          }
        }
        m.prog('tun', V.tuns.filter((T) => T.done).length);
        const near = V.tuns.find((T) => !T.done && m.near(me, T.x, T.y, RING + 300));
        m.get('food').text = (near ? `${NAMES[near.k]}守意：${Math.max(0, Math.round(near.res))}%　` : '') + `軍糧：${Math.max(0, Math.round(100 - ((w.t - V.t0) / FOOD_T) * 100))}%`;
        allyTick(w, V.yj, null);
        return V.tuns.every((T) => T.done);
      },
    },
    { // 2. 攻大屯
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('tun');
        V.cx = boss(w, XHY.changxi, MAIN[0], MAIN[1], { name: '昌豨', hp: 4200, atk: 46, armor: 8, ms: 240 });
        V.guard = Array.from({ length: 8 }, (_, i) => { const a = (i / 8) * Math.PI * 2; return m.foe('huangjin', MAIN[0] + Math.cos(a) * 260, MAIN[1] + Math.sin(a) * 180, MEN); });
        V.yj.hold = [MAIN[0] + 450, MAIN[1] + 420];
        m.line('于禁', '妙才來了！我從東南面攻他的大屯。');
        m.mark('cx', MAIN[0], MAIN[1], '昌豨', false, V.cx);
        m.obj('cx', '夾攻昌豨的大屯');
        // 昌豨打不死：打到四成就去找于禁
        const pk = w.xPreKill;
        w.xPreKill = function (src, t) { if (t === V.cx) { t.hp = 1; return true; } return pk.call(this, src, t); };
      },
      tick(m, w) {
        const V = m.vars;
        allyTick(w, V.yj, null);
        return V.cx.hp < V.cx.maxHp * 0.4;
      },
    },
    { // 3. 豨詣禁降
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('cx'); m.unmark('cx');
        V.menAt = m.alive(w.units.filter((u) => u.recruit && u.owner === me)).length;
        Object.assign(V.cx, { untargetable: true, target: null, aggro: null, home: [V.yj.x - 80, V.yj.y], ms: 200 });
        for (const u of m.alive(V.guard)) { u.team = 0; u.recruit = true; u.name = '降兵'; u.target = null; m.join(u, me); }
        V.yj.hold = [V.yj.x, V.yj.y];
        m.line('昌豨', '……我不降夏侯淵。文則與我有舊，我去降文則。');
        m.after(7, () => {
          m.card('豨與禁有舊，詣禁降。禁曰：「諸君不知公常令乎！圍而後降者不赦。」……垂泣而斬之。', '《于禁傳》');
          vanish(w, V.cx);
        });
        m.after(14, () => m.card('淵還，拜典軍校尉。軍中爲之語曰：「典軍校尉夏侯淵，三日五百，六日一千。」', '《夏侯淵傳》；《魏書》（裴注）'));
        m.after(20, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const V = m.vars;
    if (V.yj && !V.yj.alive) V.yjDown = true;
    if (!w.player.alive) m.lose('夏侯淵陣亡');
    else if (m.i < 2 && w.t - V.t0 > FOOD_T) m.lose('數月糧盡，只得退兵');
  },
};
